import { Action } from '@/_core/fluxstore/types';
import { RichTextEditorState, CardLinkEntry, createCardLinkKey } from '../types';
import { useRichTextEditorModule } from '../useModule';

const { registerReducer } = useRichTextEditorModule();

/**
 * Action to set or update a card link entry in the store.
 * Used internally by the store's ensureCardLinkLoaded method.
 */
export class SetCardLinkEntry extends Action<RichTextEditorState> {
    public static ACTION_TYPE = 'RichTextEditor::SetCardLinkEntry';

    public constructor(
        public cardId: string,
        public storymapSlug: string | null,
        public entry: CardLinkEntry
    ) {
        super(SetCardLinkEntry.ACTION_TYPE);
    }
}

const reducer = (state: RichTextEditorState, action: SetCardLinkEntry): void => {
    const key = createCardLinkKey(action.cardId, action.storymapSlug);
    state.cardLinksByKey[key] = action.entry;
};

//@ts-ignore
registerReducer(SetCardLinkEntry.ACTION_TYPE, reducer);
